<template>
  <v-container>

    <v-row>
      <v-col cols="12" class="text-center">
        <SubmissionListFilterCard/>
      </v-col>
      <v-col v-if="!trashed" cols="4">
        <v-card>
          <v-card-text>
            <v-col class="text-center">
              <v-btn
                  @click="delete_items"
                  :disabled="selected.length===0"
                  color="primary"
                  block
              >
                انتقال به سطل آشغال
              </v-btn>
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col v-else cols="4">
        <v-card>
          <v-card-text>
            <v-col class="text-center">
              <v-btn
                  :disabled="selected.length===0"
                  color="primary"
                  block
                  @click="restore_items"
              >
                بازگردانی از سطل آشغال
              </v-btn>
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col class="text-center" cols="12">
        <v-chip color="primary" large>
          تعداد : {{ count }}
        </v-chip>
      </v-col>
      <v-col>
        <v-data-table
            v-model="selected"
            :headers="submission_headers"
            :items="submissions"
            :items-per-page="25"
            class="elevation-4 row-pointer mb-4"
            :loading="loading"
            loading-text="لطفا صبر کنید"
            no-data-text="داده ای یافت نشد."
            :hide-default-footer="true"
            show-select
            item-key="submission.id"
            value="submission.id"
            @click:row="row_click"
        >
          <template v-slot:item.submitter.user_type="{ item }">
            <v-chip
                dark>
              {{ get_user_text(item.submitter.user_type) }}
            </v-chip>
          </template>
          <template v-slot:item.submitter.edit_enabled="{item}">
            <v-chip :color="!item.submitter.edit_enabled?'green':'red'">
              {{ !item.submitter.edit_enabled ? 'تایید شده' : 'تایید نشده' }}
            </v-chip>
          </template>


          <template v-slot:item.submission.edit_enabled="{item}">
            <v-chip :color="!item.submission.edit_enabled?'green':'red'">
              {{ !item.submission.edit_enabled ? 'تایید شده' : 'تایید نشده' }}
            </v-chip>
          </template>


          <template v-for="i in headers.filter((f)=>{
            return f.type==='select'
            })" v-slot:[`item.`+i.value]="{item}">
            <v-chip :color="get_object_value(item,i.value+'.color')">
              {{ get_object_value(item, i.value + '.value') }}
            </v-chip>
          </template>


          <template v-slot:item.submission.process_status="{ item }">
            <v-chip
                :color="get_status_color(item.submission.process_status)"
                dark>
              {{ get_status_text(item.submission.process_status) }}
            </v-chip>
          </template>
          <template v-slot:item.submission.category="{ item }">
            <v-chip>
              {{ get_category(item.submission.category) }}
            </v-chip>
          </template>
          <template v-slot:item.submitter.full_name="{ item }">
            <v-chip>
              {{ item.submitter.first_name + ' ' +item.submitter.last_name}}
            </v-chip>
          </template>
          <template v-if="!trashed" v-slot:item.delete="{ item }">
            <v-btn
                id="delete_btn"
                color="error"
                rounded
                @click="delete_item($event,item)">
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>


          <template v-else v-slot:item.delete="{ item }">
            <v-btn
                color="error"
                rounded
                @click="restore_item($event,item)">
              <v-icon>
                mdi-restore
              </v-icon>
            </v-btn>
          </template>


        </v-data-table>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-pagination
          v-model="page"
          :length="$store.state.Admin.admin.submission_list.number_of_pages"
      ></v-pagination>
    </v-row>
    <TrashSubmissionDialog fetch_list/>
  </v-container>
</template>

<script>
import {mapState} from "vuex";
import SubmissionListFilterCard from "@/components/admin/Cards/SubmissionListFilterCard";
import TrashSubmissionDialog from "@/components/admin/Dialogs/TrashSubmissionDialog";
import Statics from "@/components/common/Statics";

export default {
  name: "SubmissionsList",
  components: {TrashSubmissionDialog, SubmissionListFilterCard},
  mounted() {
    this.$store.commit('set_trashed', this.trashed)
    this.api_call()
  },
  props: {
    trashed: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      submission_categories: Statics.submission_categories,
      user_types: Statics.user_types,
      submission_headers: [
        {text: "ایدی اثر", value: 'submission.id'},
        {text: "تایید پروفایل", value: 'submitter.edit_enabled'},
        {text: "تایید اثر", value: 'submission.edit_enabled'},
        {text: 'دسته بندی اثر', value: 'submission.category'},
        {text: 'نوع صاحب اثر', value: 'submitter.user_type'},
        {text: "صاحب اثر", value: "submitter.full_name"},
        {text: "استان", value: 'submitter.state'},
        {text: "حذف اثر", value: 'delete'},
      ],
    }
  },
  methods: {
    get_category(number) {
      let text = ""
      this.submission_categories.forEach((element) => {
        if (element.value === number) {
          text = element.name
        }
      })
      return text
    },
    get_user_text(status) {
      let text = ""
      this.user_types.forEach((element) => {
        if (element.value === status) {
          text = element.name
        }
      })
      return text
    },
    get_object_value(o, s) {
      s = s.replace(/\[(\w+)\]/g, '.$1');
      s = s.replace(/^\./, '');
      let a = s.split('.');
      for (let i = 0, n = a.length; i < n; ++i) {
        let k = a[i];
        if (k in o) {
          o = o[k];
        } else {
          return;
        }
      }
      return o;
    },
    row_click(item) {
      this.$router.push({name: 'SubmissionItem', params: {'id': item.submission.id}})
    },
    delete_item(event, item) {
      //prevent row click
      event.stopPropagation();

      this.$store.commit('open_trash_submission_dialog', {items: [item], restore: false})
    },
    delete_items() {
      this.$store.commit('open_trash_submission_dialog', {items: this.selected, restore: false})
    },
    restore_item(event, item) {
      //prevent row click
      event.stopPropagation();

      this.$store.commit('open_trash_submission_dialog', {items: [item], restore: true})
    },
    restore_items() {
      this.$store.commit('open_trash_submission_dialog', {items: this.selected, restore: true})
    },
    api_call() {
      this.$store.dispatch('get_submission_list_headers').then(() => {
        this.$store.dispatch('get_submission_list_filters').then(() => {
          this.$store.dispatch('filter_submission').catch(()=>{
          })
      })
      })
    },
    // this.$store.state.Admin.admin.submission_list.filter.filtered)
    get_status_color(status) {
      switch (status) {
        case'uploaded':
          return '#000';
        case  'backing_up':
          return '#bd9354';
        case      'backing_up_error':
          return '#ff0000';
        case      'backed_up':
          return '#5db5c4';
        case      'verified':
          return '#000';
        case      'uploading_to_kavimo':
          return '#bd9354';
        case      'uploaded_to_kavimo':
          return '#73c45d';
        case      'error_uploading_to_kavimo':
          return '#ff0000';
        case      'deleting_original_file':
          return '#000';
        case      'deleted_original_file':
          return '#000';
        case      'error_deleting_original_file':
          return '#000';
        case      'finished':
          return '#000';

        default:
          // code block
      }
    },
    get_status_text(status) {
      switch (status) {
        case'uploaded':
          return 'آپلود شده توسط دانش آموز';
        case  'backing_up':
          return 'در حال بک آپ گرفتن';
        case      'backing_up_error':
          return 'مشکل در بک آپ';
        case      'backed_up':
          return 'بک آپ گرفته شده';
        case      'uploading_to_kavimo':
          return 'در حال آپلود در کاویمو';
        case      'uploaded_to_kavimo':
          return 'آپلود شده در کاویمو';
        case      'error_uploading_to_kavimo':
          return 'مشکل هنگام آپلود در کایمو';
        case      'deleting_original_file':
          return 'در حال پاک کردن فایل اصلی';
        case      'deleted_original_file':
          return 'فایل اصلی پاک شد';
        case      'error_deleting_original_file':
          return 'مشکل در پاک کردن فایل اصلی';
        case      'finished':
          return 'اتمام پردازش';
        default:
          // code block
      }
    },
  },
  computed: {
    selected: {
      get() {
        return this.$store.state.Admin.admin.submission_list.selected
      },
      set(value) {
        this.$store.commit('set_submission_list_selected', value)
      }
    },
    page: {
      get() {
        return this.$store.state.Admin.admin.submission_list.page
      },
      set(value) {
        this.$store.state.Admin.admin.submission_list.items = []
        this.$store.commit('set_admin_page', value)
        this.api_call()
      }
    },
    ...mapState({
      headers: state => state.Admin.admin.submission_list.headers,
      submissions: state => state.Admin.admin.submission_list.items,
      count: state => state.Admin.admin.submission_list.count,
      loading: state => state.Admin.admin.loading,
    })
  }
  , watch: {
    trashed: function () {
      this.$store.commit('set_trashed', this.trashed)
      this.api_call()
    },
  }
}
</script>

<style>
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}

tbody tr {
  cursor: pointer;
}
</style>
